module.exports = __webpack_public_path__ + "img/4.f209e9c7.png";